<template>
    <container>
        <row>
            <column :col="12" :md="8" :lg="6" v-if="review.accuracy" class="pb-3">
                <small class="text-muted">
                    Listing Accuracy:
                </small>
                <form-stars-rating :value="review.accuracy" :readonly="true" onColor="primary" class="x-small" />
            </column>

            <column :col="12" :md="8" :lg="6" v-if="review.cleanlinessProperty" class="pb-3">
                <small class="text-muted">
                    Cleanliness:
                </small>
                <form-stars-rating :value="review.cleanlinessProperty" :readonly="true" onColor="primary" class="x-small" />
            </column>

            <column :col="12" :md="8" :lg="6" v-if="review.value" class="pb-3">
                <small class="text-muted">
                    Value:
                </small>
                <form-stars-rating :value="review.value" :readonly="true" onColor="primary" class="x-small" />
            </column>

            <column :col="12" :md="8" :lg="6" v-if="review.location" class="pb-3">
                <small class="text-muted">
                    Location:
                </small>
                <form-stars-rating :value="review.location" :readonly="true" onColor="primary" class="x-small" />
            </column>

            <template v-if="review.communicationProperty && review.communicationMarquis">

                <column :md="8" :lg="6" class="pb-3">
                    <small class="text-muted">
                        Communication with Representative:
                    </small>
                    <form-stars-rating :value="review.communicationProperty" :readonly="true" onColor="primary" class="x-small" />
                </column>

                <column :md="8" :lg="6" class="pb-3">
                    <small class="text-muted">
                        Communication with StayMarquis:
                    </small>
                    <form-stars-rating :value="review.communicationMarquis" :readonly="true" onColor="primary" class="x-small" />
                </column>
            </template>
            <column :md="8" :lg="6" v-else-if="review.communicationProperty" class="pb-3">
                <small class="text-muted">
                    Communication:
                </small>
                <form-stars-rating :value="review.communicationProperty" :readonly="true" onColor="primary" class="x-small" />
            </column>
            <column :md="8" :lg="6" v-else-if="review.communicationMarquis" class="pb-3">
                <small class="text-muted">
                    Communication:
                </small>
                <form-stars-rating :value="review.communicationMarquis" :readonly="true" onColor="primary" class="x-small" />
            </column>
        </row>
    </container>
</template>

<script type="text/javascript">
    import CommonComponents from '@/components/Common.vue';
    import ApiObject from '@/classes/ApiObject.js';


    export default {

        components: {
            ...CommonComponents,
        },


        props: {
            review: {
                type: ApiObject,
                required: true,
            },
        },
    };

</script>
